import {createSlice} from '@reduxjs/toolkit'
import api from "../api";
import {VIEW_STATE} from "../utils/enums";

const slice = createSlice({
    name: 'home',
    initialState: {
        viewState: VIEW_STATE.LOADING,
        home: null
    },
    reducers: {
        setViewState: (state, action) => {
            state.viewState = action.payload
        },
        setHome: (state, action) => {
            state.home = action.payload
            state.viewState = VIEW_STATE.LOADED
        },
    },
});

export default slice.reducer
const {setViewState, setHome} = slice.actions

export const getHome = () => async dispatch => {
    try {
        dispatch(setViewState(VIEW_STATE.LOADING))
        const {data} = await api.home.getHome()
        dispatch(setHome(data.data));
    } catch (e) {
        dispatch(setViewState(VIEW_STATE.ERROR))
    }
}
